/**
 * @generated SignedSource<<7750df5d4117ec1d766abab53d86e335>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchConfluencePageBlogAttachment_AtlassianSearchPage$data = {
  readonly __typename: "SearchConfluencePageBlogAttachment";
  readonly confluenceEntity: {
    readonly commentCountSummary?: {
      readonly total: number | null;
    } | null;
    readonly likesSummary?: {
      readonly count: number | null;
    } | null;
    readonly subtype?: ConfluencePageSubType | null;
  } | null;
  readonly description: string;
  readonly iconUrl: string | null;
  readonly id: string;
  readonly isVerified: boolean;
  readonly lastModified: string | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly navBoostScore?: number | null;
  readonly socialSignal: {
    readonly signal: string | null;
    readonly timestamp: string | null;
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null;
      readonly extendedProfile?: {
        readonly jobTitle: string | null;
      } | null;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  } | null;
  readonly space: {
    readonly id: string;
    readonly name: string | null;
    readonly webUiLink: string | null;
  } | null;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchConfluencePageBlogAttachment_AtlassianSearchPage";
};
export type searchConfluencePageBlogAttachment_AtlassianSearchPage$key = {
  readonly " $data"?: searchConfluencePageBlogAttachment_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchConfluencePageBlogAttachment_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "description"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "subtype"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastModified"
    },
    {
      "kind": "ScalarField",
      "name": "isVerified"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "condition": "includeNavBoostScore",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "navBoostScore"
        }
      ]
    },
    {
      "concreteType": "SearchConfluenceResultSpace",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "webUiLink"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "confluenceEntity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*: any*/),
            {
              "concreteType": "ConfluenceCommentCountSummary",
              "kind": "LinkedField",
              "name": "commentCountSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "total"
                }
              ]
            },
            {
              "concreteType": "ConfluenceLikesSummary",
              "kind": "LinkedField",
              "name": "likesSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "count"
                }
              ]
            }
          ],
          "type": "ConfluencePage"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "concreteType": "SocialSignalSearch",
      "kind": "LinkedField",
      "name": "socialSignal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "signal"
        },
        {
          "kind": "ScalarField",
          "name": "timestamp"
        },
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchConfluencePageBlogAttachment"
};
})();

(node as any).hash = "e5ac712249d432f98d92cae621cafa79";

export default node;
